import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface GalleryFile {
    uuid: string;
    fileName?: string;
}

interface FileGalleryState {
    isOpen: boolean;
    title: string;
    files: GalleryFile[];
    initialIndex: number;
}

const initialState: FileGalleryState = {
    isOpen: false,
    title: "Attachments",
    files: [],
    initialIndex: 0,
};

const fileGallerySlice = createSlice({
    name: "fileGallerySlice",
    initialState,
    reducers: {
        openFileGallery: (
            state,
            action: PayloadAction<{ files: GalleryFile[]; initialIndex?: number; title?: string }>
        ) => {
            state.files = Array.isArray(action.payload.files) ? action.payload.files : [];
            state.initialIndex = Number.isFinite(action.payload.initialIndex)
                ? (action.payload.initialIndex as number)
                : 0;
            state.title = action.payload.title ?? "Attachments";
            state.isOpen = true;
        },
        closeFileGallery: (state) => {
            state.isOpen = false;
        },
        resetFileGallery: (state) => {
            state.isOpen = false;
            state.title = "Attachments";
            state.files = [];
            state.initialIndex = 0;
        },
    },
});

export const { openFileGallery, closeFileGallery, resetFileGallery } = fileGallerySlice.actions;
export default fileGallerySlice.reducer;
